// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login_login-container__KBpPh {
  width: 100%;
  height: 100vh;
  display: flex;
  background: #f8fafc;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.Login_login-brand__gqAq6 {
  flex: 1.2 1;
  background: linear-gradient(135deg, #00b4f3 0%, #0a736b 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 40px;
  overflow: hidden;
}
.Login_login-brand__gqAq6::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
  background-size: 40px 40px;
  opacity: 0.6;
  pointer-events: none;
}
.Login_login-brand__gqAq6 .Login_brand-content__GGUce {
  text-align: left;
  color: white;
  max-width: 540px;
  position: relative;
  z-index: 1;
  animation: Login_slowFadeSlide__1mQOd 1s ease-out forwards;
}
.Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-title__xCYDs {
  font-size: 42px;
  font-weight: 700;
  margin-bottom: 20px;
  line-height: 1.2;
  letter-spacing: -0.5px;
  color: #ffffff;
}
.Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-subtitle__emUJn {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
  font-weight: 400;
  max-width: 460px;
}
.Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-features__pSgB8 {
  margin-top: 48px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-features__pSgB8 .Login_feature-item__aS3zv {
  display: flex;
  align-items: center;
  gap: 12px;
  color: rgba(255, 255, 255, 0.95);
  font-size: 15px;
  font-weight: 500;
}
.Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-features__pSgB8 .Login_feature-item__aS3zv svg {
  color: #ffffff;
  font-size: 20px;
  opacity: 0.9;
}

.Login_login-panel__VsVIb {
  flex: 1 1;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  position: relative;
  box-shadow: -10px 0 30px rgba(0, 0, 0, 0.03);
}
.Login_login-panel__VsVIb .Login_login-content__L7paK {
  width: 100%;
  max-width: 400px;
  animation: Login_simpleFadeIn__\\+LKk6 1.2s ease-out forwards;
}
.Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-header__-UIph {
  margin-bottom: 48px;
}
.Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-header__-UIph .Login_form-logo-wrapper__I-9Ly {
  margin-bottom: 24px;
  display: flex;
  align-items: center;
}
.Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-header__-UIph .Login_form-logo-wrapper__I-9Ly .Login_form-logo__rQPn3 {
  height: 48px;
  width: auto;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.05));
}
.Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-header__-UIph .Login_login-title__i\\+aCA {
  font-size: 32px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 12px;
  letter-spacing: -0.5px;
}
.Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-header__-UIph .Login_login-subtitle__rb2SR {
  font-size: 16px;
  color: #64748b;
  font-weight: 400;
}
.Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-form__XkcPR .Login_input-group__5Qkc9 {
  margin-bottom: 24px;
  position: relative;
}
.Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-form__XkcPR .Login_input-group__5Qkc9 input {
  height: 52px !important;
  border-radius: 6px !important;
  border: 1px solid #cbd5e1 !important;
  background: #ffffff !important;
  font-size: 15px !important;
  color: #0f172a !important;
  transition: all 0.2s ease !important;
}
.Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-form__XkcPR .Login_input-group__5Qkc9 input:focus {
  border-color: #00b4f3 !important;
  box-shadow: 0 0 0 3px rgba(0, 151, 178, 0.1) !important;
}
.Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-form__XkcPR .Login_input-group__5Qkc9 input::placeholder {
  color: #94a3b8 !important;
}
.Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-form__XkcPR .Login_input-group__5Qkc9 label {
  font-weight: 600 !important;
  color: #334155 !important;
  margin-bottom: 8px !important;
  font-size: 14px !important;
  display: block;
}
.Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-form__XkcPR button {
  margin-top: 32px;
  height: 52px !important;
  border-radius: 6px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  background: #00b4f3 !important;
  border: none !important;
  color: white !important;
  transition: all 0.2s ease !important;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-form__XkcPR button:hover:not(:disabled) {
  background: #0a736b !important;
}
.Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-form__XkcPR button:active:not(:disabled) {
  background: #085a54 !important;
}
.Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-form__XkcPR button:disabled {
  background: #cbd5e1 !important;
  opacity: 0.7 !important;
  cursor: not-allowed;
}
.Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-footer__\\+PtkH {
  margin-top: 48px;
  text-align: center;
  padding-top: 24px;
}
.Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-footer__\\+PtkH p {
  font-size: 14px;
  color: #94a3b8;
  margin: 0;
}

@keyframes Login_slowFadeSlide__1mQOd {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes Login_simpleFadeIn__\\+LKk6 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@media (max-width: 992px) {
  .Login_login-brand__gqAq6 {
    flex: 1 1;
    padding: 30px;
  }
  .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-title__xCYDs {
    font-size: 32px;
  }
}
@media (max-width: 768px) {
  .Login_login-container__KBpPh {
    flex-direction: column;
  }
  .Login_login-brand__gqAq6 {
    flex: 0 0 auto;
    min-height: 45vh;
    padding: 40px 24px;
  }
  .Login_login-brand__gqAq6 .Login_brand-content__GGUce {
    text-align: center;
  }
  .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-features__pSgB8 {
    display: none;
  }
  .Login_login-panel__VsVIb {
    flex: 1 1;
    padding: 40px 24px;
    z-index: 2;
  }
  .Login_login-panel__VsVIb .Login_login-content__L7paK {
    max-width: 100%;
  }
  .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-header__-UIph {
    margin-bottom: 32px;
    text-align: center;
  }
  .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-header__-UIph .Login_login-title__i\\+aCA {
    font-size: 28px;
  }
  .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-form__XkcPR button {
    margin-top: 24px;
  }
}
@media (max-width: 480px) {
  .Login_login-brand__gqAq6 {
    padding: 32px 20px;
  }
  .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-title__xCYDs {
    font-size: 26px;
  }
  .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-subtitle__emUJn {
    font-size: 15px;
  }
  .Login_login-panel__VsVIb {
    padding: 32px 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/auth/Login/Login.module.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uFACE;AADJ;;AAUA;EACE,WAAA;EACA,6DAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AAPF;AAUE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yJACE;EAEF,0BAAA;EACA,YAAA;EACA,oBAAA;AAVJ;AAaE;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,0DAAA;AAXJ;AAaI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;AAXN;AAcI;EACE,eAAA;EACA,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAZN;AAeI;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAbN;AAeM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;AAbR;AAeQ;EACE,cAAA;EACA,eAAA;EACA,YAAA;AAbV;;AAqBA;EACE,SAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,4CAAA;AAlBF;AAoBE;EACE,WAAA;EACA,gBAAA;EACA,4DAAA;AAlBJ;AAoBI;EACE,mBAAA;AAlBN;AAoBM;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;AAlBR;AAoBQ;EACE,YAAA;EACA,WAAA;EACA,kDAAA;AAlBV;AAsBM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;AApBR;AAuBM;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AArBR;AA0BM;EACE,mBAAA;EACA,kBAAA;AAxBR;AA0BQ;EACE,uBAAA;EACA,6BAAA;EACA,oCAAA;EACA,8BAAA;EACA,0BAAA;EACA,yBAAA;EACA,oCAAA;AAxBV;AA0BU;EACE,gCAAA;EACA,uDAAA;AAxBZ;AA2BU;EACE,yBAAA;AAzBZ;AA6BQ;EACE,2BAAA;EACA,yBAAA;EACA,6BAAA;EACA,0BAAA;EACA,cAAA;AA3BV;AA+BM;EACE,gBAAA;EACA,uBAAA;EACA,6BAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,uBAAA;EACA,uBAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AA7BR;AA+BQ;EACE,8BAAA;AA7BV;AAiCQ;EACE,8BAAA;AA/BV;AAkCQ;EACE,8BAAA;EACA,uBAAA;EACA,mBAAA;AAhCV;AAqCI;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;AAnCN;AAqCM;EACE,eAAA;EACA,cAAA;EACA,SAAA;AAnCR;;AA0CA;EACE;IACE,UAAA;IACA,2BAAA;EAvCF;EAyCA;IACE,UAAA;IACA,wBAAA;EAvCF;AACF;AA0CA;EACE;IACE,UAAA;EAxCF;EA0CA;IACE,UAAA;EAxCF;AACF;AA4CA;EACE;IACE,SAAA;IACA,aAAA;EA1CF;EA6CI;IACE,eAAA;EA3CN;AACF;AAgDA;EACE;IACE,sBAAA;EA9CF;EAiDA;IACE,cAAA;IACA,gBAAA;IACA,kBAAA;EA/CF;EAiDE;IACE,kBAAA;EA/CJ;EAiDI;IACE,aAAA;EA/CN;EAoDA;IACE,SAAA;IACA,kBAAA;IACA,UAAA;EAlDF;EAoDE;IACE,eAAA;EAlDJ;EAoDI;IACE,mBAAA;IACA,kBAAA;EAlDN;EAoDM;IACE,eAAA;EAlDR;EAuDM;IACE,gBAAA;EArDR;AACF;AA2DA;EACE;IACE,kBAAA;EAzDF;EA4DI;IACE,eAAA;EA1DN;EA4DI;IACE,eAAA;EA1DN;EA+DA;IACE,kBAAA;EA7DF;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap\");\n\n.login-container {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  background: #f8fafc;\n  font-family:\n    \"Inter\",\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    Roboto,\n    sans-serif;\n}\n\n// Left side - Branding using main colors\n.login-brand {\n  flex: 1.2;\n  background: linear-gradient(135deg, #00b4f3 0%, #0a736b 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  padding: 40px;\n  overflow: hidden;\n\n  // Formal subtle grid overlay\n  &::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-image:\n      linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),\n      linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);\n    background-size: 40px 40px;\n    opacity: 0.6;\n    pointer-events: none;\n  }\n\n  .brand-content {\n    text-align: left;\n    color: white;\n    max-width: 540px;\n    position: relative;\n    z-index: 1;\n    animation: slowFadeSlide 1s ease-out forwards;\n\n    .brand-title {\n      font-size: 42px;\n      font-weight: 700;\n      margin-bottom: 20px;\n      line-height: 1.2;\n      letter-spacing: -0.5px;\n      color: #ffffff;\n    }\n\n    .brand-subtitle {\n      font-size: 18px;\n      color: rgba(255, 255, 255, 0.9);\n      line-height: 1.6;\n      font-weight: 400;\n      max-width: 460px;\n    }\n\n    .brand-features {\n      margin-top: 48px;\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n\n      .feature-item {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        color: rgba(255, 255, 255, 0.95);\n        font-size: 15px;\n        font-weight: 500;\n\n        svg {\n          color: #ffffff;\n          font-size: 20px;\n          opacity: 0.9;\n        }\n      }\n    }\n  }\n}\n\n// Right side - Login Form\n.login-panel {\n  flex: 1;\n  background: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  position: relative;\n  box-shadow: -10px 0 30px rgba(0, 0, 0, 0.03); // Slight depth to separate left and right visually\n\n  .login-content {\n    width: 100%;\n    max-width: 400px;\n    animation: simpleFadeIn 1.2s ease-out forwards; // Clear traditional fade in\n\n    .login-header {\n      margin-bottom: 48px;\n\n      .form-logo-wrapper {\n        margin-bottom: 24px;\n        display: flex;\n        align-items: center;\n\n        .form-logo {\n          height: 48px;\n          width: auto;\n          filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.05));\n        }\n      }\n\n      .login-title {\n        font-size: 32px;\n        font-weight: 700;\n        color: #0f172a;\n        margin-bottom: 12px;\n        letter-spacing: -0.5px;\n      }\n\n      .login-subtitle {\n        font-size: 16px;\n        color: #64748b;\n        font-weight: 400;\n      }\n    }\n\n    .login-form {\n      .input-group {\n        margin-bottom: 24px;\n        position: relative;\n\n        input {\n          height: 52px !important;\n          border-radius: 6px !important; // More formal/traditional border radius\n          border: 1px solid #cbd5e1 !important;\n          background: #ffffff !important;\n          font-size: 15px !important;\n          color: #0f172a !important;\n          transition: all 0.2s ease !important; // Formal, quick transition\n\n          &:focus {\n            border-color: #00b4f3 !important;\n            box-shadow: 0 0 0 3px rgba(0, 151, 178, 0.1) !important;\n          }\n\n          &::placeholder {\n            color: #94a3b8 !important;\n          }\n        }\n\n        label {\n          font-weight: 600 !important;\n          color: #334155 !important;\n          margin-bottom: 8px !important;\n          font-size: 14px !important;\n          display: block;\n        }\n      }\n\n      button {\n        margin-top: 32px;\n        height: 52px !important;\n        border-radius: 6px !important; // Match input border radius for traditional feel\n        font-size: 16px !important;\n        font-weight: 600 !important;\n        background: #00b4f3 !important; // Solid formal color instead of gradient on button\n        border: none !important;\n        color: white !important;\n        transition: all 0.2s ease !important;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        gap: 8px;\n\n        &:hover:not(:disabled) {\n          background: #0a736b !important;\n          // Removed hover translate for a more static, traditional feel\n        }\n\n        &:active:not(:disabled) {\n          background: #085a54 !important;\n        }\n\n        &:disabled {\n          background: #cbd5e1 !important;\n          opacity: 0.7 !important;\n          cursor: not-allowed;\n        }\n      }\n    }\n\n    .login-footer {\n      margin-top: 48px;\n      text-align: center;\n      padding-top: 24px;\n\n      p {\n        font-size: 14px;\n        color: #94a3b8;\n        margin: 0;\n      }\n    }\n  }\n}\n\n// Formal Animations\n@keyframes slowFadeSlide {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes simpleFadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n// Responsive Design\n@media (max-width: 992px) {\n  .login-brand {\n    flex: 1;\n    padding: 30px;\n\n    .brand-content {\n      .brand-title {\n        font-size: 32px;\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .login-container {\n    flex-direction: column;\n  }\n\n  .login-brand {\n    flex: 0 0 auto;\n    min-height: 45vh;\n    padding: 40px 24px;\n\n    .brand-content {\n      text-align: center;\n\n      .brand-features {\n        display: none; // Hide extra features on mobile to save space\n      }\n    }\n  }\n\n  .login-panel {\n    flex: 1;\n    padding: 40px 24px;\n    z-index: 2;\n\n    .login-content {\n      max-width: 100%;\n\n      .login-header {\n        margin-bottom: 32px;\n        text-align: center;\n\n        .login-title {\n          font-size: 28px;\n        }\n      }\n\n      .login-form {\n        button {\n          margin-top: 24px;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .login-brand {\n    padding: 32px 20px;\n\n    .brand-content {\n      .brand-title {\n        font-size: 26px;\n      }\n      .brand-subtitle {\n        font-size: 15px;\n      }\n    }\n  }\n\n  .login-panel {\n    padding: 32px 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"login-container": `Login_login-container__KBpPh`,
	"login-brand": `Login_login-brand__gqAq6`,
	"brand-content": `Login_brand-content__GGUce`,
	"slowFadeSlide": `Login_slowFadeSlide__1mQOd`,
	"brand-title": `Login_brand-title__xCYDs`,
	"brand-subtitle": `Login_brand-subtitle__emUJn`,
	"brand-features": `Login_brand-features__pSgB8`,
	"feature-item": `Login_feature-item__aS3zv`,
	"login-panel": `Login_login-panel__VsVIb`,
	"login-content": `Login_login-content__L7paK`,
	"simpleFadeIn": `Login_simpleFadeIn__+LKk6`,
	"login-header": `Login_login-header__-UIph`,
	"form-logo-wrapper": `Login_form-logo-wrapper__I-9Ly`,
	"form-logo": `Login_form-logo__rQPn3`,
	"login-title": `Login_login-title__i+aCA`,
	"login-subtitle": `Login_login-subtitle__rb2SR`,
	"login-form": `Login_login-form__XkcPR`,
	"input-group": `Login_input-group__5Qkc9`,
	"login-footer": `Login_login-footer__+PtkH`
};
export default ___CSS_LOADER_EXPORT___;
